import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { DashboardContainerComponent } from './dashboard-container/dashboard-container.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';

const routes: Routes = [
  {
    path: 'dashboards',
    canActivate: [AuthorizeGuard, RightsGuard],
    component: DashboardContainerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class DashboardRoutingModule {}
